import { Pipe } from "@angular/core";

@Pipe({
    name: "idCardPipe"
})
export class IDCardPipe {
    transform(rawNum: any) {
        console.log(rawNum);
        let idCardNumber = '';
        if (rawNum) {
            const firstStr = rawNum.slice(0, 1);
            const secondStr = rawNum.slice(1, 5);
            const thirdStr = rawNum.slice(5, 10);
            const fourthStr = rawNum.slice(10, 12);
            const fifthStr = rawNum.slice(12, 13);
            idCardNumber = `${firstStr}-${secondStr}-${thirdStr}-${fourthStr}-${fifthStr}`;
        }
        return idCardNumber 
    }
}

